import { IQPPictureLoadCtrl } from "../qp-picture-loading";
import { AbstractPictureState, ILoadState } from "./abstract-picture-state";

export class PictureLoadfailState extends AbstractPictureState {

    public name: ILoadState = "loadfail";

    constructor() {
        super();
    }

    /**
     * @description 设置图片加载失败后的样式
     * 
     */
    public setStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        const elem = imageElem[0] as HTMLImageElement;
        elem.src = context.missingImg;
        elem.title = context.errorTitle;
    }

    /**
     * @description 清除当前状态样式,在切换状态前被调用
     * 
     */
    public cleanStyle(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        const elem = imageElem[0] as HTMLImageElement;
        elem.title = "";
    }


    /**
     * @description 设置当前状态下可用方法,在切换状态后被调用
     * 
     */
    public setAction(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        const elem = imageElem[0] as HTMLImageElement;
        imageElem.on("click", () => {

            if (context.loadType == "POLLING" && elem.src != context.entry.target['dataset'].src) {
                // mockup图,点击发起重新生成
                // 重置Retry次数
                context.overplusTimes = context.options.times;
                context.reCreatMockup();
            }
            if (context.loadType == "LOADING" && elem.src != context.entry.target['dataset'].src) {
                // 普通图片,点击后发起重试
                // 重置Retry次数
                context.overplusTimes = context.options.times;
                // 执行Retry
                context.doRetry();
            }
        })
    }



    public cleanAction(imageElem: JQLite, context: IQPPictureLoadCtrl): void {
        imageElem.off("click");
    }
}